// Class: openfl.utils.IDataOutput

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IDataOutput = function() {}

// Meta

IDataOutput.__name__ = "openfl.utils.IDataOutput";
IDataOutput.__isInterface__ = true;
IDataOutput.prototype = {
	
};
IDataOutput.prototype.__class__ = IDataOutput.prototype.constructor = $hxClasses["openfl.utils.IDataOutput"] = IDataOutput;

// Init



// Statics




// Export

exports.default = IDataOutput;